import {BaseDomainModel} from "../../../infrastructure/models/base-domain-model";

export class NewsSourceDomainModel extends BaseDomainModel {
  id: Number;
  name: String;
  imageVersion: Number;

  constructor(apiModel: NewsSourceDomainModel) {
    super(apiModel);

    this.id = apiModel.id;
    this.name = apiModel.name;
    this.imageVersion = apiModel.imageVersion;
  }
}